import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useAppSelector } from '../../store/hooks';
import { FiMenu } from 'react-icons/fi';
import SideNav from './SideNav';

const MainLayout: React.FC = () => {
  const colors = useAppSelector((state) => state.theme.theme);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div
      className="flex min-h-screen"
      style={{ backgroundColor: colors.backgroundColor, color: colors.textColor }}
    >
      {/* Mobile Header with hamburger menu */}
      <header
        className="lg:hidden fixed top-0 left-0 right-0 h-14 flex items-center px-4 z-40 border-b"
        style={{
          backgroundColor: colors.glassBackground || colors.backgroundColor,
          borderColor: colors.glassBorder || colors.borderColor,
          backdropFilter: 'blur(12px)',
          WebkitBackdropFilter: 'blur(12px)',
          boxShadow: colors.shadowSoft,
        }}
      >
        <button
          onClick={() => setMobileMenuOpen(true)}
          className="p-2 rounded-xl hover:opacity-80 transition-all duration-200 active:scale-95"
          style={{
            backgroundColor: colors.inputBackground,
            boxShadow: colors.shadowSoft,
          }}
        >
          {React.createElement(FiMenu as any, { size: 22, color: colors.textColor })}
        </button>
        <div className="flex items-center gap-2 ml-3">
          <img
            src="/logos/logo-tech.svg"
            alt="Yantrai"
            className="w-8 h-8 rounded-lg"
            style={{ boxShadow: colors.shadowGlow }}
          />
          <span className="font-semibold gradient-text">
            Yantrai
          </span>
        </div>
      </header>

      {/* Mobile Sidebar Drawer */}
      {mobileMenuOpen && (
        <>
          {/* Backdrop */}
          <div
            className="fixed inset-0 bg-black/50 z-50 lg:hidden"
            onClick={() => setMobileMenuOpen(false)}
          />
          {/* Mobile SideNav */}
          <SideNav isMobile onClose={() => setMobileMenuOpen(false)} />
        </>
      )}

      {/* Side Navigation - Desktop only (lg+) */}
      <SideNav />

      {/* Main Content - add top padding for mobile header */}
      <main className="flex-1 lg:ml-72 pt-14 lg:pt-0 overflow-y-auto min-h-screen">
        <div className="w-full h-full animate-fade-in">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default MainLayout;
